import Granim from 'granim';
import Config from 'assets/js/site/_site-config';

export default new Granim({
    element: '.submenu-gradient',
    name: 'granim',
    direction: 'top-bottom', // 'diagonal', 'top-bottom'
    opacity: [1, 1, 1],
    isPausedWhenNotInView: true,
    scrollDebounceThreshold: 300,
    states : {
        "default-state": {
            gradients: Config.gradients,
            transitionSpeed: 2000,
            loop: true
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/site/_submenu-gradient.js